import { strategy } from "./providers";
export const {
  captureException,
  identify,
  initialize,
  onRouterTransitionStart,
} = strategy;
